import { render } from "./TransactionJson.vue?vue&type=template&id=48f4d4a0&scoped=true"
import script from "./TransactionJson.vue?vue&type=script&lang=js"
export * from "./TransactionJson.vue?vue&type=script&lang=js"

import "./TransactionJson.vue?vue&type=style&index=0&id=48f4d4a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f4d4a0"]])

export default __exports__